
import { storage } from "@/CommonDP/utils";
function getObjectFromSessionStorage(name) {
  const json = storage.get(name);
  return json ? JSON.parse(json) : {};
}

const monge = {
  state: {
    dwgdata: getObjectFromSessionStorage('dwgdata'), // 图纸信息
    spaceOfDwgData: '', // 图纸空间的fileName
    annotationData: '', // 云线数据
    annotationList: [], // 所有云线信息
    spaceQmList: [], // 当前空间下的问题列表
    hasDwg: false,
    modeldata: getObjectFromSessionStorage('modeldata'), // 模型信息
    modelProperty: '', // 模型构件信息
    dwgModelId: '', // 模型图纸的模型id
    modelPageFileName: '', // 模型图纸名称
    isShowComponentInfo: false,
    currentComponent: {},
    section: { // 剖切
      type: '', // 支持x,y,z
      pos: ''
    },
    modelquestionData: getObjectFromSessionStorage("modelquestionData") // 问题信息

  },
  actions: {
    setDwgData({ commit }, val) {
      commit('dealDwgData', val);
    },
    setSpaceOfDwgData({ commit }, val) {
      commit('dealSpaceOfDwgData', val);
    },
    setAnnotationData({ commit }, val) {
      commit('dealAnnotationData', val);
    },
    setAnnotationList({ commit }, val) {
      commit('dealAnnotationList', val);
    },
    setSpaceQmList({ commit }, val) {
      commit('dealSpaceQmList', val);
    },

    setModeldata({ commit }, val) {
      commit('dealModeldata', val);
    },
    setModelProperty({ commit }, val) {
      commit('dealModelProperty', val);
    },
    isShowComponentInfo ({ commit }, data) {
      commit('IS_SHOW_COMPONENT_INFO', data);
    },
    currentComponent ({ commit }, data) {
      commit('CURRENT_COMPONENT', data);
    },
    setSectionType({ commit }, type) {
      commit('dealSectionType', type);
    },
    setDwgModelId({ commit }, id) {
      commit('dealDwgModelId', id);
    },
    setmodelPageFileName({ commit }, val) {
      commit('dealmodelPageFileName', val);
    },
    setModelquestionData({ commit }, data) {
      commit('dealModelquestionData', data);
    },
    setHasDwg({ commit }, boolean) {
      commit('dealHasDwg', boolean);
    }
  },
  mutations: {
    dealDwgData(state, val) {
      storage.set('dwgdata', val ? JSON.stringify(val) : "");
      state.dwgdata = val;
    },
    dealSpaceOfDwgData(state, val) {
      state.spaceOfDwgData = val;
    },
    dealAnnotationData(state, val) {
      state.annotationData = val;
    },
    dealAnnotationList(state, val) {
      state.annotationList = val;
    },
    dealSpaceQmList(state, val) {
      state.spaceQmList = val;
    },

    dealModeldata(state, val) {
      storage.set('modeldata', val ? JSON.stringify(val) : "");
      state.modeldata = val;
    },
    dealModelProperty(state, val) {
      state.modelProperty = val;
    },
    dealSectionType(state, type) {
      state.section.type = type;
    },
    IS_SHOW_COMPONENT_INFO (state, data) {
      state.isShowComponentInfo = data;
    },
    CURRENT_COMPONENT (state, data) {
      state.currentComponent = data;
    },
    dealDwgModelId(state, id) {
      state.dwgModelId = id;
    },
    dealmodelPageFileName(state, val) {
      state.modelPageFileName = val;
    },
    dealModelquestionData(state, data) {
      storage.set("modelquestionData", data ? JSON.stringify(data) : "");
      state.modelquestionData = data;
    },
    dealHasDwg(state, boolean) {
      state.hasDwg = boolean;
    }

  }

};

export default monge;
